export const environment = {
  production: false,

  dms: {
    api_base_url: 'https://dmsapi.di11soft.com',
  },

   admin: {
    api_base_url: 'https://admindevapi.di11soft.com',
  },

  otp: {
    otp_base_url: 'https://otp.di11soft.com',
  },


  version: '1.0.0',
};